module.exports = __webpack_public_path__ + "static/media/award.6c75b9d2.png";